"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[67777],{

/***/ 971219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ GiftColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const GiftColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 26 26", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { filter: "url(#filter0_d)" },
        child: [
          {
            tag: "path",
            attr: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M11.6364 6.9847L8.7767 5.151C8.25219 4.81467 7.55366 5.06457 7.35706 5.65888L6.79962 7.34394C6.57498 8.02303 7.1381 8.70292 7.84136 8.60169L11.0885 8.13427C11.0798 8.20942 11.0754 8.28587 11.0754 8.36336C11.0754 9.44791 11.9479 10.3271 13.0242 10.3271C14.1006 10.3271 14.9731 9.44791 14.9731 8.36336C14.9731 8.2883 14.9689 8.21422 14.9608 8.14135L18.1588 8.60169C18.862 8.70292 19.4252 8.02303 19.2005 7.34394L18.6431 5.65888C18.4465 5.06457 17.7479 4.81467 17.2234 5.151L14.3933 6.96575C14.0413 6.6157 13.5578 6.39962 13.0242 6.39962C12.4811 6.39962 11.9898 6.62351 11.6364 6.9847Z",
              fill: "url(#paint0_linear)"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M6.04004 11.2901C6.04004 10.7583 6.46789 10.3271 6.99567 10.3271H19.0044C19.5322 10.3271 19.96 10.7583 19.96 11.2901V19.8687C19.96 20.4005 19.5322 20.8316 19.0044 20.8316H6.99567C6.46789 20.8316 6.04004 20.4005 6.04004 19.8687V11.2901Z",
              fill: "url(#paint1_linear)"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M5 8.73245C5 8.20065 5.42785 7.76953 5.95563 7.76953H20.0444C20.5722 7.76953 21 8.20065 21 8.73245V11.3294C21 11.8613 20.5722 12.2924 20.0444 12.2924H5.95563C5.42785 12.2924 5 11.8613 5 11.3294V8.73245Z",
              fill: "url(#paint2_radial)"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M10.71 7.76953H15.2899V12.2924H10.71V7.76953Z",
              fill: "#FED546"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M11.0269 12.2925H14.9729V20.8316H11.0269V12.2925Z",
              fill: "url(#paint3_linear)"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "filter",
            attr: {
              id: "filter0_d",
              x: "0",
              y: "0",
              width: "26",
              height: "25.8316",
              filterUnits: "userSpaceOnUse",
              colorInterpolationFilters: "sRGB"
            },
            child: [
              {
                tag: "feFlood",
                attr: { floodOpacity: "0", result: "BackgroundImageFix" }
              },
              {
                tag: "feColorMatrix",
                attr: {
                  in: "SourceAlpha",
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                }
              },
              { tag: "feOffset", attr: {} },
              { tag: "feGaussianBlur", attr: { stdDeviation: "2.5" } },
              {
                tag: "feColorMatrix",
                attr: {
                  type: "matrix",
                  values: "0 0 0 0 1 0 0 0 0 0.528167 0 0 0 0 0.379167 0 0 0 0.29 0"
                }
              },
              {
                tag: "feBlend",
                attr: {
                  mode: "normal",
                  in2: "BackgroundImageFix",
                  result: "effect1_dropShadow"
                }
              },
              {
                tag: "feBlend",
                attr: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "effect1_dropShadow",
                  result: "shape"
                }
              }
            ]
          },
          {
            tag: "linearGradient",
            attr: {
              id: "paint0_linear",
              x1: "13.0001",
              y1: "5",
              x2: "13.0001",
              y2: "8.30689",
              gradientUnits: "userSpaceOnUse"
            },
            child: [
              { tag: "stop", attr: { stopColor: "#FFB81E" } },
              { tag: "stop", attr: { offset: "1", stopColor: "#FED546" } }
            ]
          },
          {
            tag: "linearGradient",
            attr: {
              id: "paint1_linear",
              x1: "13",
              y1: "10.3271",
              x2: "13",
              y2: "20.8316",
              gradientUnits: "userSpaceOnUse"
            },
            child: [
              { tag: "stop", attr: { stopColor: "#FF2B2B" } },
              { tag: "stop", attr: { offset: "1", stopColor: "#FF2E6C" } }
            ]
          },
          {
            tag: "radialGradient",
            attr: {
              id: "paint2_radial",
              cx: "0",
              cy: "0",
              r: "1",
              gradientUnits: "userSpaceOnUse",
              gradientTransform: "translate(7.61979 9.61593) rotate(61.073) scale(9.30482 8.68326)"
            },
            child: [
              { tag: "stop", attr: { stopColor: "#FF5B6F" } },
              {
                tag: "stop",
                attr: { offset: "0.46875", stopColor: "#FF444F" }
              }
            ]
          },
          {
            tag: "linearGradient",
            attr: {
              id: "paint3_linear",
              x1: "12.9999",
              y1: "12.2925",
              x2: "12.9999",
              y2: "20.8316",
              gradientUnits: "userSpaceOnUse"
            },
            child: [
              {
                tag: "stop",
                attr: { stopColor: "#FFB81E", stopOpacity: "0.66" }
              },
              {
                tag: "stop",
                attr: { offset: "0.608277", stopColor: "#FFB81E" }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};




/***/ }),

/***/ 235904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ PreLoad; },
/* harmony export */   "g": function() { return /* binding */ Loading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _contexts_GlobalDataContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(684443);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80912);




const Loading = (param)=>{
    let { isLoading , children  } = param;
    var ref;
    const { logo  } = (0,_contexts_GlobalDataContext__WEBPACK_IMPORTED_MODULE_2__/* .useGlobalData */ .U5)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Loading */ .g, {
        isLoading: isLoading,
        logo: (ref = (logo === null || logo === void 0 ? void 0 : logo.loading) || (logo === null || logo === void 0 ? void 0 : logo.lite)) === null || ref === void 0 ? void 0 : ref.path,
        children: children
    });
};
const PreLoad = (param)=>{
    let { isLoading , height  } = param;
    var ref;
    const { logo  } = (0,_contexts_GlobalDataContext__WEBPACK_IMPORTED_MODULE_2__/* .useGlobalData */ .U5)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Loading */ .g, {
        isLoading: isLoading,
        style: {
            height: typeof height === "number" ? "".concat(height, "px") : height
        },
        logo: (ref = (logo === null || logo === void 0 ? void 0 : logo.loading) || (logo === null || logo === void 0 ? void 0 : logo.lite)) === null || ref === void 0 ? void 0 : ref.path
    });
};


/***/ }),

/***/ 905006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ ComboItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(634655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(290184);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(971219);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(526397);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(47649);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(933756);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(662295);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(446586);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(428247);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(670894);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(618428);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(806748);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(991822);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(591007);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  border-radius: 8px;\n  padding: 1.5rem 0 1rem 1.5rem;\n  background-color: #ffffff;\n  margin-bottom: 1rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 3;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1;\n  border-left: 1px solid #e4e5f0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 1.5rem;\n  width: 100%;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  margin-top: 1rem;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  margin-right: 3rem;\n  width: 125px;\n  cursor: pointer;\n  &.not-last-item {\n    &:after {\n      content: '+';\n      position: absolute;\n      right: -1.75rem;\n      top: 58px;\n      color: #a7abc3;\n      font-size: 18px;\n      cursor: auto;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  width: 125px;\n  height: 125px;\n  background-color: rgba(27, 29, 41, 0.5);\n  color: #ffffff;\n  z-index: 1;\n  top: 0;\n  left: 0;\n  font-size: 20px;\n  line-height: 28px;\n  font-weight: 700;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = _taggedTemplateLiteral([
        "\n  margin-top: 8px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 125px;\n  &:before {\n    content: ' ';\n    position: absolute;\n    left: -1.5rem;\n    color: #e4e5f0;\n    border-right: 1px solid #a7abc3;\n    height: 125px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-top: 8px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = _taggedTemplateLiteral([
        "\n  text-transform: uppercase;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  height: 16px;\n  background-color: #a7abc3;\n  border-radius: 999px;\n  font-size: 10px;\n  font-weight: 500;\n  line-height: 12px;\n  color: white;\n  padding: 2px 5px;\n  top: 8px;\n  left: 8px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    const data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}









const ComboItem = (_param)=>{
    var { comboItem , onAddToCart , onViewDetail  } = _param, rest = _objectWithoutProperties(_param, [
        "comboItem",
        "onAddToCart",
        "onViewDetail"
    ]);
    const { trackingScreenName  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useScreen */ .EV)();
    const maxSlotProduct = comboItem.type === "autogen" ? 4 : 3;
    const renderPrice = (product)=>{
        var ref, ref1, ref2, ref3;
        const latestPrice = Number(product === null || product === void 0 ? void 0 : (ref = product.prices) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.latestPrice) || 0;
        const supplierRetailPrice = Number(product === null || product === void 0 ? void 0 : (ref2 = product.prices) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.supplierRetailPrice) || 0;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_3__/* .ProductPrice */ .j, {
            latestPrice: latestPrice,
            supplierRetailPrice: supplierRetailPrice,
            textColor: "#434657"
        });
    };
    const renderPromotion = ()=>{
        if (!comboItem.promotion) return null;
        const priceWithoutCombo = comboItem.items.reduce((acc, curr)=>{
            var ref, ref1, ref2;
            const currLatestPrice = Number((ref = curr.product) === null || ref === void 0 ? void 0 : (ref1 = ref.prices) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.latestPrice) || 0;
            return acc + currLatestPrice * curr.quantity;
        }, 0);
        const promotionDetail = (0,helpers__WEBPACK_IMPORTED_MODULE_4__/* .getComboPromotionDetail */ .g5)(comboItem.promotion, priceWithoutCombo);
        const { tag , discount , title , description , icon , image  } = promotionDetail || {};
        const bottom = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledWrapperTag, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledTag, {
                    type: "ghost",
                    variant: "branding",
                    content: tag || ""
                }),
                !!discount && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_3__/* .ProductPrice */ .j, {
                    latestPrice: discount,
                    textColor: "#434657"
                }),
                !!title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledProductName, {
                    level: 1,
                    line: 2,
                    color: "#434657",
                    children: title
                }),
                !!description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledProductName, {
                    level: 1,
                    line: 2,
                    color: "#82869E",
                    children: description
                })
            ]
        });
        if (icon) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(PromotionWrapper, {
                children: [
                    icon === "cash" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledBgPromotion, {
                        bgColor: "#E7FBED",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__/* .CashColored */ .B, {
                            size: 60
                        })
                    }),
                    icon === "gift" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledBgPromotion, {
                        bgColor: "#FFF2F0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__/* .GiftColored */ .x, {
                            size: 60
                        })
                    }),
                    icon === "voucher" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledBgPromotion, {
                        bgColor: "#FFF2F0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_7__/* .VoucherColored */ .C, {
                            size: 60
                        })
                    }),
                    bottom
                ]
            });
        } else {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(PromotionWrapper, {
                children: [
                    image ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .LazyImage */ .w, {
                        imageWidth: 200,
                        width: 125,
                        height: 125,
                        contain: true,
                        borderRadius: 1,
                        src: image
                    }) : null,
                    bottom
                ]
            });
        }
    };
    const handleViewDetailCombo = ()=>{
        (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_9__/* .trackManually */ .gu)("viewComboDetail", "productComboItem", trackingScreenName || "ProductDetail", JSON.stringify({
            skus: comboItem.items.map((el)=>el.product.productInfo.sku),
            promotionId: comboItem.promotionId,
            screenName: trackingScreenName,
            type: comboItem.type
        }));
        onViewDetail();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, _objectSpreadProps(_objectSpread({}, rest), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                style: {
                    display: "flex",
                    justifyContent: "space-between"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ComboOverview, {
                        children: [
                            comboItem.items.map((item, index, list)=>{
                                const link = {
                                    href: {
                                        pathname: "/products/".concat(item.product.productInfo.sku)
                                    }
                                };
                                const exceedMaxSlot = list.length > maxSlotProduct;
                                const isCompactItem = exceedMaxSlot && index === maxSlotProduct - 1;
                                if (exceedMaxSlot && index >= maxSlotProduct) return null;
                                const isLastItem = exceedMaxSlot ? index === maxSlotProduct - 1 : index === list.length - 1;
                                const renderedItem = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledLazyImage, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .LazyImage */ .w, {
                                                    imageWidth: 200,
                                                    width: 125,
                                                    height: 125,
                                                    contain: true,
                                                    borderRadius: 4,
                                                    src: item.product.productInfo.imageUrl
                                                }),
                                                isCompactItem && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledRemainBg, {
                                                    children: [
                                                        "+",
                                                        list.length - index
                                                    ]
                                                }),
                                                !isCompactItem && item.quantity > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(QuantityTag, {
                                                    children: [
                                                        item.quantity,
                                                        "x"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledProductName, {
                                            level: 1,
                                            line: 2,
                                            color: isCompactItem ? "#82869E" : "#434657",
                                            style: isCompactItem ? {
                                                textAlign: "center"
                                            } : {},
                                            children: isCompactItem ? (0,i18n__WEBPACK_IMPORTED_MODULE_10__.t)("v\xe0 {{var0}} sản phẩm kh\xe1c", {
                                                var0: list.length - index
                                            }) : item.product.productInfo.name
                                        }),
                                        isCompactItem ? null : renderPrice(item.product)
                                    ]
                                });
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ItemWrapper, {
                                    className: !isLastItem ? "not-last-item" : "",
                                    children: isCompactItem ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        onClick: handleViewDetailCombo,
                                        children: renderedItem
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__/* .CustomLink */ .x, _objectSpreadProps(_objectSpread({}, link), {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", _objectSpreadProps(_objectSpread({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_12__/* .getTrackingData */ .O5)({
                                            index,
                                            regionName: "combo",
                                            contentName: item.product.productInfo.sku,
                                            target: "productDetail"
                                        })), {
                                            children: renderedItem
                                        }))
                                    }))
                                }, index);
                            }),
                            renderPromotion()
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SummaryCol, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Summary, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_3__/* .ProductPrice */ .j, {
                                    size: "l",
                                    latestPrice: comboItem.latestPrice,
                                    supplierRetailPrice: comboItem.supplierRetailPrice
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AddComboButtonWrapper, _objectSpreadProps(_objectSpread({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_12__/* .getTrackingData */ .O5)({
                                    isTrackContent: true,
                                    regionName: "productComboItem",
                                    contentName: "addToCart",
                                    target: trackingScreenName,
                                    payload: JSON.stringify({
                                        skus: comboItem.items.map((el)=>el.product.productInfo.sellerSku),
                                        promotionId: comboItem.promotionId,
                                        screenName: trackingScreenName,
                                        type: comboItem.type
                                    })
                                })), {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledButton, {
                                        variant: "secondary",
                                        block: true,
                                        onClick: onAddToCart,
                                        className: "att-add-product-combo-to-cart",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .SubTitle */ .DK, {
                                            level: 2,
                                            weight: "medium",
                                            children: (0,i18n__WEBPACK_IMPORTED_MODULE_10__.t)("Th\xeam v\xe0o giỏ")
                                        })
                                    })
                                })),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledButton, {
                                    block: true,
                                    onClick: handleViewDetailCombo,
                                    className: "att-view-detail-combo",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .SubTitle */ .DK, {
                                        level: 2,
                                        weight: "medium",
                                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_10__.t)("Xem chi tiết")
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            comboItem.type === "dynamic" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledWarning, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_14__/* .CautionOutlined */ .s, {
                        color: "pending600",
                        size: 24
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .Body */ .uT, {
                        level: 1,
                        color: "pending600",
                        marginLeft: "s8",
                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_10__.t)("Kh\xf4ng \xe1p dụng c\xf9ng 1 số khuyến m\xe3i kh\xe1c")
                    })
                ]
            })
        ]
    }));
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_15__["default"].div(_templateObject());
const ComboOverview = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_15__["default"].div(_templateObject1());
const SummaryCol = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_15__["default"].div(_templateObject2());
const Summary = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_15__["default"].div(_templateObject3());
const StyledButton = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_15__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_16__/* .Button */ .z)(_templateObject4());
const ItemWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_15__["default"].div(_templateObject5());
const StyledLazyImage = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_15__["default"].div(_templateObject6());
const StyledRemainBg = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_15__["default"].div(_templateObject7());
const StyledProductName = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_15__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .Caption */ .YS)(_templateObject8());
const StyledWarning = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_15__["default"].div((param)=>{
    let { theme  } = param;
    return "\n  display: flex;\n  align-items: center;\n  margin-top: 1rem;\n  margin-right: 1.5rem;\n  background-color: ".concat(theme === null || theme === void 0 ? void 0 : theme.colors.pending50, ";\n  height: 40px;\n  line-height: 40px;\n  border-radius: 4px;\n  padding-left: 12px;\n");
});
const PromotionWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_15__["default"].div(_templateObject9());
const StyledBgPromotion = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_15__["default"].div((param)=>{
    let { bgColor  } = param;
    return "\n  width: 125px;\n  height: 125px;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: ".concat(bgColor, ";\n  border-radius: 4px;\n  &:before {\n    content: ' ';\n    position: absolute;\n    left: -1.5rem;\n    color: #e4e5f0;\n    border-right: 1px solid #e4e5f0;\n    height: 125px;\n  }\n");
});
const StyledWrapperTag = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_15__["default"].div(_templateObject10());
const StyledTag = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_15__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_17__/* .Tag */ .V)(_templateObject11());
const QuantityTag = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_15__["default"].div(_templateObject12());
const AddComboButtonWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_15__["default"].div(_templateObject13());


/***/ })

}]);